export default __webpack_public_path__ + "static/media/share.f758eefc.mp4";